import { UiIcon } from "shared/uikit";
import { ICONS } from "shared/constants";
import { observer } from "mobx-react";
import { useEffect } from "react";

import "./styles.scss";
import { useStore } from 'shared/hooks';
import { Portal } from 'react-portal';

type PPWDWidgetNoticeProps = {
    text: string;
    isOpen: boolean;
    autoHideDuration?: number;
    onClose?: () => void;
};

export const PPWDWidgetNotice = observer(({
    text = "",
    isOpen,
    autoHideDuration = 5000,
    onClose = () => {}
}: PPWDWidgetNoticeProps) => {

    const store = useStore(() => ({
        isVisible: false
    }))

    useEffect(() => {
        let timer: NodeJS.Timeout | null = null;

        if (isOpen) {
            store.set("isVisible", true)

            timer = setTimeout(() => {
                handleClose();
            }, autoHideDuration);
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [isOpen, autoHideDuration]);

    const handleClose = () => {
        store.set("isVisible", false)

        setTimeout(() => {
            onClose();
        }, 300);
    };

    if (!isOpen) return null;

    return (
        <Portal>
            <div className={`ppd-widget-notice ${store.isVisible ? "visible" : "hidden"}`}>
                <div className="ppd-widget-notice__text">{text}</div>
                <button
                    type="button"
                    className="ppd-widget-notice__close"
                    onClick={handleClose}
                >
                    <UiIcon icon={ICONS.CLOSE} size={20} color={"#FFFFFF"} />
                </button>
            </div>
        </Portal>

    );
});
